import gql from "graphql-tag";

export const ME_FOR_ACCOUNT_PAGE = gql`
  query meForAccountPage {
    me {
      id
      firstName
      skinType
      skinConcern
      point {
        id
        availableAmount
      }
      notReviewedProducts {
        id
        brand
        name
        productType {
          id
        }
        images {
          id
          url (size: 120)
          alt
        }
      }
    }
    orders(status: READY_TO_FULFILL){
      totalCount
    }
  }
`;